import { useRef, useState } from 'react'
import classNames from 'classnames'
import { arrayOf, bool, func, object, string } from 'prop-types'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { RCTooltip } from 'components/RCTooltip'
import SimpleCard from 'components/SimpleCard'
import { T } from 'lib/tolgee'

import Popover from '../../components/Popover'
import './index.scss'

const { PopoverWrapper, Popover: PopoverContent } = Popover

function SimpleDropdown({ label, onChange, options, selected, disabled, tooltipText, tooltipPlace }) {
  const simpleDropdownRef = useRef()
  const [open, setOpen] = useState(false)

  function toggle(open) {
    setOpen(disabled ? false : open)
  }

  function change(opts) {
    if (opts.isDisabled) return
    onChange?.(opts)
    toggle(false)
  }

  const selectClass = classNames('selected-value', { opened: open, disabled })

  return (
    <div className="simple-dropdown-container">
      {label && <span className="label"> {label} </span>}

      <PopoverWrapper popoverElement={simpleDropdownRef.current}>
        <div ref={node => (simpleDropdownRef.current = node)} onClick={toggle} className={selectClass}>
          {selected?.tolgee ? (
            <T keyName={selected.tolgee.key}>{selected.tolgee.defaultValue}</T>
          ) : (
            <>{selected.label}</>
          )}
          <Icon className="drop-icon" icon="arrowDown" width={18} height={18} />
          {tooltipText && (
            <RCTooltip direction={tooltipPlace || 'right'} tooltipMessage={tooltipText}>
              <div className="top-icon question-mark">
                <Icon fill="var(--primary_light1)" icon="questionMark" width={24} height={24} />
              </div>
            </RCTooltip>
          )}
        </div>

        <PopoverContent visible={open} onVisibleChange={toggle} alignX="right">
          <SimpleCard>
            <ul>
              {options.map(option => {
                const optionClass = classNames('option', {
                  active: selected.value === option.value,
                  disabled: option.isDisabled,
                })

                return (
                  <li className={optionClass} onClick={() => change(option)} key={option.label}>
                    <TooltipWrapper tooltipMessage={option.tooltipText} tooltipStyle="tooltippedS" isTooltipMultiline>
                      <span className="simple-dropdown-container-label">
                        {option.tolgee ? (
                          <T keyName={option.tolgee.key}>{option.tolgee.defaultValue}</T>
                        ) : (
                          <>{option.label}</>
                        )}
                      </span>
                    </TooltipWrapper>
                    {option.subLabel && <span className="simple-dropdown-container-sublabel">{option.subLabel}</span>}
                  </li>
                )
              })}
            </ul>
          </SimpleCard>
        </PopoverContent>
      </PopoverWrapper>
    </div>
  )
}

SimpleDropdown.propTypes = {
  label: string,
  onChange: func,
  options: arrayOf(object),
  selected: object,
  disabled: bool,
  tooltipText: string,
  tooltipPlace: string,
}

export default SimpleDropdown
